var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7V6H13V4H12V2H11V0H9V2H8V4H7V6H6V7H0V9H1V10H2V11H3V12H4V16H3V18H2V20H5V19H7V18H8V17H12V18H13V19H15V20H18V18H17V16H16V12H17V11H18V10H19V9H20V7H14ZM14 10V11H13V13H14V15H12V14H8V15H6V13H7V11H6V10H5V9H8V8H9V6H11V8H12V9H15V10H14Z",
    fill: "#F89344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFilledStar);
export default __webpack_public_path__ + "static/media/not_filled_star.33651bd4399192a01494e5c22c726b98.svg";
export { ForwardRef as ReactComponent };